import { specimensApi } from './index'

export default specimensApi.middleware
